import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { BackButton, hasHistory, useBack } from "@/components/BackButton";

const ROOTS = ["/", "/dashboard"];
const FLOATING = [/^\/login/, /^\/forgot-password/, /^\/reset-password/, /^\/follow\//, /^\/c\//];

const typing = (el) => el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));

export const NavHelpers = () => {
  const { pathname } = useLocation();
  const type = useNavigationType();
  const { back } = useBack();
  useEffect(() => { if (type !== "POP") window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname, type]);
  useEffect(() => {
    const onKey = (e) => {
      if (/^\/(overlay|panel)\//.test(pathname)) return;
      if (e.key === "Escape" && pathname.startsWith("/editor")) return;
      if (e.altKey && e.key === "ArrowLeft") {
        if (!hasHistory()) { e.preventDefault(); back(); }
        return;
      }
      if (e.key !== "Escape" || e.defaultPrevented || typing(document.activeElement)) return;
      if (document.querySelector('[role="dialog"], [role="menu"], [role="listbox"]')) return;
      if (ROOTS.includes(pathname) && !hasHistory()) return;
      back();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [pathname, back]);
  if (!FLOATING.some((r) => r.test(pathname))) return null;
  return <div className="fixed top-4 left-4 z-[60]"><BackButton testid="floating-back-btn" /></div>;
};

export const Fade = ({ children }) => <div className="cx-page-in">{children}</div>;
